import React from 'react'
import { useIntl } from 'react-intl'

import Divider from './Divider'
import SummaryAdditionalNotes from './SummaryAdditionalNotes'
import SummaryDataItem from './SummaryDataItem'

type Props = {
  phone?: string
  url?: string
  notes?: string
}

function ExtraDetails({ url, phone, notes }: Props) {
  const intl = useIntl()
  if (!url && !phone && !notes) return null

  const websiteLabel = intl.formatMessage({
    id: '1SUa7tN2NqADYiUWROe9',
    defaultMessage: 'Website',
    description: 'Form field label for website link in trip item extra details',
  })
  const phoneNumberLabel = intl.formatMessage({
    id: 'tKB7sv5K6TQDVaD6JvCh',
    defaultMessage: 'Phone number',
    description: 'Form field label for phone number in trip item extra details',
  })

  return (
    <>
      <Divider />
      <SummaryDataItem title={websiteLabel} value={url} url={url} />
      <SummaryDataItem
        title={phoneNumberLabel}
        value={phone}
        url={`tel:${phone}`}
      />
      <SummaryAdditionalNotes notes={notes} />
    </>
  )
}

export default ExtraDetails
